var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pagamentosPessoa)?_c('div',{staticClass:"c3 col-grow-1 text-right"},[_vm._v("Recebeu R$"+_vm._s(_vm._f("moeda")(_vm.totalPago)))]):_c('div',{staticClass:"c3 col-grow-1 text-right status-0"},[_vm._v("Nada pago")])
}
var staticRenderFns = []

export { render, staticRenderFns }